import { alpha, styled } from '@mui/system'
import Dialog from '../../molecules/dialog'

const DialogStyled = styled(Dialog)`
	.MuiPaper-root {
		display: block;
		overflow: hidden;
		margin: 0;
		background: var(--color-grey110);
	}

	.swiper-container {
		height: 100%;
	}

	.swiper-button-prev {
		right: var(--spacing-10);
		padding: calc(var(--spacing) * 1.25);
		width: 40px;
		height: 40px;
		bottom: var(--spacing-2);
		top: auto;
		left: auto;
		border-radius: 50%;
		background-color: var(--color-white);
		color: var(--color-primary);
		border: 1px solid var(--color-grey40);
		z-index: 11;
		${({ theme }) => theme.breakpoints.up('md')} {
			width: 60px;
			height: 60px;
			left: 40px;
			right: auto;
			padding: 14px;
			top: 50%;
		}
	}
	.swiper-button-next {
		right: var(--spacing-2);
		padding: calc(var(--spacing) * 1.25);
		width: 40px;
		height: 40px;
		bottom: var(--spacing-2);
		top: auto;
		border-radius: 50%;
		background-color: var(--color-white);
		color: var(--color-primary);
		border: 1px solid var(--color-grey40);
		z-index: 11;
		${({ theme }) => theme.breakpoints.up('md')} {
			right: 40px;
			width: 60px;
			height: 60px;
			bottom: auto;
			padding: 14px;
			top: 50%;
		}
	}

	.MuiIconButton-root.iconClose {
		right: var(--spacing-2);
		top: var(--spacing-2);
		background-color: var(--color-white);
		padding: calc(var(--spacing) * 1.25);
		border: 1px solid var(--color-grey40);
		width: 40px;
		height: 40px;
		${({ theme }) => theme.breakpoints.up('md')} {
			padding: 21px;
			right: 40px;
			top: 40px;
			width: 60px;
			height: 60px;
		}

		.MuiSvgIcon-root {
			font-size: ${({ theme }) => theme.typography.pxToRem(18)};
		}
	}
`

const ItemWrapper = styled('div')`
	height: 100%;
	width: 100%;
	.react-transform-wrapper {
		width: 100%;
		height: 100%;
		.react-transform-component {
			width: 100%;
			height: 100%;
		}
	}
`

const SliderThumbsWrapper = styled('div')`
	width: 75px;
	position: absolute;
	z-index: 99;
	top: 50%;
	transform: translateY(-50%);
	display: none;
	left: 160px;
	max-height: calc(100dvh - 70px);
	overflow-y: auto;
	${({ theme }) => theme.scrollbar};

	${({ theme }) => theme.breakpoints.up('md')} {
		display: block;
	}

	.swiper-slide {
		cursor: pointer;
		height: auto !important;
		&:before {
			border: ${({ theme }) => `1px solid ${alpha(theme.palette.white.main, 0.6)}`};
			bottom: 0;
			content: '';
			left: 0;
			position: absolute;
			right: 0;
			top: 0;
			z-index: 1;
		}
		&-thumb-active:before {
			border: 2px solid var(--color-primary);
		}
	}
`

const MouseMoveWrapper = styled('div')`
	display: flex;
	align-items: center;
	justify-content: center;
	height: auto;
	width: 100%;
	position: absolute;
	.noscript-hide {
		height: 100vh;
	}
`

export { DialogStyled, ItemWrapper, SliderThumbsWrapper, MouseMoveWrapper }
